{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Персонализирани атрибути",
    "HEADER_BTN_TXT": "Add Custom Attribute",
    "LOADING": "Fetching custom attributes",
    "DESCRIPTION": "A custom attribute tracks additional details about your contacts or conversations—such as the subscription plan or the date of their first purchase. You can add different types of custom attributes, such as text, lists, or numbers, to capture the specific information you need.",
    "LEARN_MORE": "Learn more about custom attributes",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Текст",
      "NUMBER": "Число",
      "LINK": "Връзка",
      "DATE": "Дата",
      "LIST": "Списък",
      "CHECKBOX": "Отметка",
      "TEXT_AREA": "Текстово поле"
    },
    "ADD": {
      "TITLE": "Add Custom Attribute",
      "SUBMIT": "Създаване",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "FORM": {
        "NAME": {
          "LABEL": "Display Name",
          "PLACEHOLDER": "Enter custom attribute display name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Enter custom attribute description",
          "ERROR": "Description is required"
        },
        "MODEL": {
          "LABEL": "Applies to",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Model is required"
        },
        "TYPE": {
          "LABEL": "Тип",
          "PLACEHOLDER": "Please select a type",
          "ERROR": "Type is required",
          "LIST": {
            "LABEL": "List Values",
            "PLACEHOLDER": "Please enter value and press enter key",
            "ERROR": "Must have at least one value"
          }
        },
        "KEY": {
          "LABEL": "Ключ",
          "PLACEHOLDER": "Enter custom attribute key",
          "ERROR": "Key is required",
          "IN_VALID": "Невалиден ключ"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex Pattern",
          "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Enable regex validation"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Custom Attribute added successfully!",
        "ERROR_MESSAGE": "Could not create a Custom Attribute. Please try again later."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Изтрий",
      "API": {
        "SUCCESS_MESSAGE": "Custom Attribute deleted successfully.",
        "ERROR_MESSAGE": "Couldn't delete the custom attribute. Try again."
      },
      "CONFIRM": {
        "TITLE": "Are you sure want to delete - {attributeName}",
        "PLACE_HOLDER": "Please type {attributeName} to confirm",
        "MESSAGE": "Deleting will remove the custom attribute",
        "YES": "Изтриване ",
        "NO": "Отмени"
      }
    },
    "EDIT": {
      "TITLE": "Промяна на персонализиран атрибут",
      "UPDATE_BUTTON_TEXT": "Обновяване",
      "TYPE": {
        "LIST": {
          "LABEL": "Показване на стойности",
          "PLACEHOLDER": "Моля, въведете стойност и натиснете клавиш enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Персонализирания атрибут е обновен успешно",
        "ERROR_MESSAGE": "Възникна грешка при обновяване на персонализирания атрибут, моля опитайте отново"
      }
    },
    "TABS": {
      "HEADER": "Персонализирани атрибути",
      "CONVERSATION": "Разговор",
      "CONTACT": "Контакт"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Име",
        "DESCRIPTION": "Описание",
        "TYPE": "Тип",
        "KEY": "Ключ"
      },
      "BUTTONS": {
        "EDIT": "Редактирай",
        "DELETE": "Изтрий"
      },
      "EMPTY_RESULT": {
        "404": "Няма създадени персонализирани атрибути",
        "NOT_FOUND": "Няма настроени персонализирани атрибути"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex Pattern",
        "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Enable regex validation"
      }
    }
  }
}
